<div (mousedown)="onMouseDown($event)" (mouseup)="onMouseUp($event)" (mousemove)="onMouseMove($event)" class="flex column center w-100 bg-pdf relative" [ngClass]="{'grabbing': isDragging}">
	@if (loading && showLoader) {
		<mat-spinner [diameter]="30" color="primary"></mat-spinner>
	}
	<pdf-viewer [src]="src" [render-text]="true" [(page)]="startAt" [style]="viewerStyles" (after-load-complete)="onPdfLoaded($event)"
		[zoom]="zoomTo" zoom-scale="page-fit" [fit-to-page]="true">
	</pdf-viewer>
	@if (showZoomOptions) {
		<div class="zoom-btns">
			<button mat-flat-button class="zoom-btn" (click)="zoomIn()">
				<mat-icon class="m-0" svgIcon="zoom_in"></mat-icon>
			</button>
			<button mat-flat-button (click)="zoomOut()" class="zoom-btn">
				<mat-icon class="m-0" svgIcon="zoom_out"></mat-icon>
			</button>
		</div>
	}
</div>
